import client from '../../shared/api/client';
import { PaginatedResponse } from '../../shared/types';

export type BankAccountStatus = 'pending' | 'approved' | 'rejected';

export interface AdminBankAccount {
  id: number;
  user_id: number;
  user_email?: string | null;
  user_name?: string | null;
  bank_name: string;
  payment_method_code?: string | null;
  account_holder_name: string;
  account_number: string;
  currency: string;
  swift_bic?: string | null;
  iban?: string | null;
  routing_number?: string | null;
  label?: string | null;
  status: BankAccountStatus;
  rejection_reason?: string | null;
  selected_for_p2p: boolean;
  reviewed_at?: string | null;
  created_at: string;
}

export interface BankAccountListFilters {
  status?: BankAccountStatus;
  user_id?: number;
  search?: string;
  page?: number;
  per_page?: number;
}

interface BankAccountListResponse {
  success: boolean;
  data: PaginatedResponse<AdminBankAccount>;
}

export const listBankAccounts = async (
  filters: BankAccountListFilters = {}
): Promise<PaginatedResponse<AdminBankAccount>> => {
  const response = await client.get<BankAccountListResponse>('/bank-accounts', {
    params: filters,
  });
  return response.data.data;
};

export const approveBankAccount = async (id: number): Promise<void> => {
  await client.post(`/bank-accounts/${id}/approve`);
};

export const rejectBankAccount = async (id: number, reason: string): Promise<void> => {
  await client.post(`/bank-accounts/${id}/reject`, { reason });
};
